<div class="flex flex-col min-h-screen">
  <div class="navbar bg-base-100 shadow-sm px-4 md:px-10">
    <div class="flex-1">
      <a routerLink="/" class="btn btn-ghost p-0 hover:bg-transparent">
        <img ngSrc="logo.jpg" class="h-10 w-auto" height="1024" width="1024" alt="Logo Kids Gonflables Party"/>
      </a>
    </div>
    <div class="flex-none">
      <ul class="menu menu-horizontal px-1 hidden md:flex">
        <li><a routerLink="">Accueil</a></li>
        <li><a routerLink="/chateaux">Châteaux</a></li>
        <li><a routerLink="/contact">Contact</a></li>
      </ul>
      <div class="dropdown dropdown-end md:hidden">
        <button tabindex="0" class="btn btn-ghost btn-circle">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h7" /></svg>
        </button>
        <ul tabindex="0" class="menu menu-sm dropdown-content mt-3 z-[1] p-2 shadow bg-base-100 rounded-box w-52">
          <li><a routerLink="">Accueil</a></li>
          <li><a routerLink="/chateaux">Châteaux</a></li>
          <li><a routerLink="/contact">Contact</a></li>
        </ul>
      </div>
    </div>
  </div>

  <main class="flex-grow">
    <router-outlet></router-outlet>
  </main>

  <footer class="footer items-center p-4 bg-base-300 flex flex-row justify-between ">
    <aside class="items-center">
      <p>© 2026 - Kids Gonflables Party</p>
    </aside>

    <nav class="flex flex-row gap-4">
      <a href="https://www.facebook.com/KidsGonflables"
         target="_blank"
         class="hover:text-primary transition-colors">
        <div class="flex items-center gap-2">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" class="fill-current">
            <path d="M9 8h-3v4h3v12h5v-12h3.642l.358-4h-4v-1.667c0-.955.192-1.333 1.115-1.333h2.885v-5h-3.808c-3.596 0-5.192 1.583-5.192 4.615v3.385z"></path>
          </svg> Rejoignez nous sur Facebook
        </div>
      </a>
    </nav>
  </footer>
</div>
